export const desktopMenuList = [
    { name: "Home", iconClass: "fas fa-home", color: "#2c3e50" },

    // {
    //     name: "Courses",
    //     iconClass: "fas fa-book",
    //     color: "#8e44ad",
    //     panel: [
    //         [
    //             { type: "menu-title", name: "Front End Development", iconClass: "fas fa-code", color: "#34495e" },
    //             { type: "panel-list-item", name: "HTML/CSS,js", iconClass: "fab fa-html5", color: "#e34c26" },
    //             { type: "panel-list-item", name: "Bootstrap", iconClass: "fab fa-bootstrap", color: "#563d7c" },
    //             { type: "panel-list-item", name: "ReactJS", iconClass: "fab fa-react", color: "#61DBFB" },
    //             { type: "panel-list-item", name: "AngularJS", iconClass: "fab fa-angular", color: "#dd1b16" },
    //             { type: "panel-list-item", name: "NextJS", iconClass: "fas fa-forward", color: "#000000" },

    //         ],
    //         [
    //             { type: "menu-title", name: "Backend Development", iconClass: "fas fa-server", color: "#7f8c8d" },
    //             { type: "panel-list-item", name: "Java", iconClass: "fab fa-java", color: "#f89820" },
    //             { type: "panel-list-item", name: "C", iconClass: "fas fa-copyright", color: "#2980b9" },
    //             { type: "panel-list-item", name: "C++", iconClass: "fas fa-code", color: "#3498db" },
    //             { type: "panel-list-item", name: "C#", iconClass: "fas fa-code", color: "#9b59b6" },
    //             { type: "panel-list-item", name: "Python", iconClass: "fab fa-python", color: "#3776ab" },
    //             { type: "panel-list-item", name: "Expressjs", iconClass: "fas fa-bolt", color: "#808080" },
    //             { type: "panel-list-item", name: "PHP", iconClass: "fab fa-php", color: "#8892be" },

    //         ],
    //         [
    //             { type: "menu-title", name: "Database Management", iconClass: "fas fa-database", color: "#34495e" },
    //             { type: "panel-list-item", name: "SQL", iconClass: "fas fa-table", color: "#bdc3c7" },
    //             { type: "panel-list-item", name: "MySQL", iconClass: "fas fa-database", color: "#00758f" },
    //             { type: "panel-list-item", name: "MongoDB", iconClass: "fas fa-leaf", color: "#4db33d" },
    //             { type: "panel-list-item", name: "PostgreSQL", iconClass: "fas fa-server", color: "#336791" },

    //         ],
    //         [
    //             { type: "menu-title", name: "Algorithm Concepts", iconClass: "fas fa-brain", color: "#f39c12" },
    //             { type: "panel-list-item", name: "Artificial Intelligence", iconClass: "fas fa-robot", color: "#7f8c8d" },
    //             { type: "panel-list-item", name: "Data Structure and Algorithm", iconClass: "fas fa-sitemap", color: "#1abc9c" },
    //             { type: "panel-list-item", name: "Cyber Security", iconClass: "fas fa-shield-alt", color: "#c0392b" },
    //             { type: "panel-list-item", name: "Ethical Hacking", iconClass: "fas fa-user-secret", color: "#2c3e50" },
    //             { type: "panel-list-item", name: "Machine Learning", iconClass: "fas fa-project-diagram", color: "#9b59b6" },
    //             { type: "panel-list-item", name: "Data Analysis", iconClass: "fas fa-chart-bar", color: "#2980b9" },

    //         ],
    //     ],
    // },

    {
        name: "IT Training Institute",
        iconClass: "fas fa-tools",
        href: "https://course.cybersoftdev.com",
        color: "#16a085",
        open: "fa-solid fa-caret-down"
    },

    // {
    //     name: "Careers  ",
    //     iconClass: "fas fa-briefcase",
    //     color: "#e67e22",
    //     children: [

    //         { name: "Web Development", href: "#", iconClass: "fas fa-code", color: "#2980b9" },
    //         { name: "Android Application", href: "#", iconClass: "fab fa-android", color: "#3ddc84" },
    //         { name: "Desktop Application", href: "#", iconClass: "fas fa-desktop", color: "#8e44ad" },
    //         { name: "AI Application ", href: "#", iconClass: "fas fa-robot", color: "#95a5a6" },
        
    //     ],
    // },


    { name: "Why Choose Us", iconClass: "fas fa-thumbs-up", color: "#27ae60" },
    { name: "Blog", href: "#", iconClass: "fas fa-blog", color: "#f1c40f" },
    { name: "Contact", href: "#", iconClass: "fas fa-phone-alt", color: "#2980b9" },
];
